import EventEmitter from './utils/EventEmitter';

export default class MenuMobile extends EventEmitter {
  constructor(element) {
    super();

    this.el = element;

    this.burgerButton = this.el.querySelector('.burger-menu-button');
    this.topNavItems = Array.from(this.el.querySelectorAll('.main-menu .nav-item'));
    this.topNavLinks = Array.from(this.el.querySelectorAll('.main-menu .nav-link'));

    this.subMenusContainer = this.el.querySelector('.sub-menus-container');
    this.subMenus = Array.from(this.el.querySelectorAll('.sub-menu'));

    this.userSubMenu = this.el.querySelector('.user-sub-menu');
    this.userMenuButton = this.el.querySelector('.user-menu-btn');
    this.userMenuButtonClickZone = this.el.querySelector('.user-menu-btn');

    this.backButton = this.el.querySelector('.t-btn-back');

    this.searchIcon = this.el.querySelector('.search-field .mobile-search-icon');

    this.events();
    this.closeUserSubMenu();
  }

  events() {
    this.burgerButton.addEventListener('click', () => {
      this.el.classList.toggle('expanded');
      this.toggleBodyScroll();
      setTimeout(() => {
        this.closeSubMenu();
      }, 450);
    });

    this.topNavLinks.forEach((link) => {
      link.addEventListener('click', (e) => {e.preventDefault();});
    });

    this.topNavItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.openSubMenu(index);
      });
    });

    this.backButton.addEventListener('click', () => {
      this.closeSubMenu();
    });

    if (this.userMenuButtonClickZone) {
      this.userMenuButtonClickZone.addEventListener('click', () => {
        if (this.userMenuButton.classList.contains('opened')) {
          this.closeUserSubMenu();
          this.userMenuButton.classList.remove('opened');
        } else {
          this.openUserSubMenu();
          this.userMenuButton.classList.add('opened');
        }
      });
    }

    this.searchIcon.addEventListener('click', () => {
      this.el.querySelector('.mobile-search-form').submit();
    });

  }

  closeSubMenu() {
    this.el.classList.remove('bck-blue4', 'bck-green-dark');
    this.subMenusContainer.classList.remove('expanded', 'bck-blue4', 'bck-green-dark');
    clearTimeout(this.closeSubMenuTimeout);
    this.closeSubMenuTimeout = setTimeout(() => {
      this.subMenus.forEach((subMenu) => {
        subMenu.classList.remove('expanded');
      });
    }, 450);
  }

  openSubMenu(index) {
    // A sub-menu reopened while the previous one is still closing must not be
    // emptied by the pending closeSubMenu() timeout.
    clearTimeout(this.closeSubMenuTimeout);
    this.el.classList.remove('bck-green-dark', 'bck-blue4');
    this.el.classList.add((index === 2) ? 'bck-blue4' : 'bck-green-dark');
    this.subMenus.forEach((subMenu, i) => {
      subMenu.classList.toggle('expanded', i === index);
    });
    this.subMenusContainer.classList.add('expanded', `${index === 2 ? 'bck-blue4' : 'bck-green-dark'}`);
  }

  closeUserSubMenu() {
    if (this.userSubMenu) {
      this.userSubMenu.style.height = '0';
    }
  }

  openUserSubMenu() {
    this.userSubMenu.style.height = `${this.userSubMenu.scrollHeight}px`;
  }

  toggleBodyScroll() {
    document.body.style.overflow = document.body.style.overflow === 'hidden' ? 'auto' : 'hidden';
  }

  searchMenu() {
    this.el.classList.remove('bck-blue4');
    this.el.classList.add('bck-green-dark');
    this.searchMenu.classList.add('expanded');
    this.searchMenu.style.height = `${this.searchMenu.scrollHeight}px`;
  }
}
